import { render, staticRenderFns } from "./compareDown.vue?vue&type=template&id=794b32dc&scoped=true&"
import script from "./compareDown.vue?vue&type=script&lang=js&"
export * from "./compareDown.vue?vue&type=script&lang=js&"
import style0 from "./compareDown.vue?vue&type=style&index=0&id=794b32dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b32dc",
  null
  
)

export default component.exports